import { gql } from "urql";
export const GetChatMessagesQuery = gql `
    query GetChatMessages($chatRoomId: String!, $cursor: String, $limit: Int) {
        chatMessages {
            messages(chatRoomId: $chatRoomId, cursor: $cursor, limit: $limit) {
                messages {
                    chatMessageId
                    chatRoomId
                    senderUserId
                    threadParentId
                    content
                    contentText
                    isEdited
                    isDeleted
                    threadReplyCount
                    threadLastReplyAt
                    senderFirstName
                    senderLastName
                    senderImageUrl
                    isPinned
                    createdAt
                    updatedAt
                    reactions {
                        chatReactionId
                        chatMessageId
                        userId
                        emoji
                        createdAt
                        firstName
                        lastName
                    }
                }
                cursor
                hasMore
            }
        }
    }
`;
export const GetThreadMessagesQuery = gql `
    query GetThreadMessages($threadParentId: String!) {
        chatMessages {
            threadMessages(threadParentId: $threadParentId) {
                chatMessageId
                chatRoomId
                senderUserId
                threadParentId
                content
                contentText
                isEdited
                isDeleted
                threadReplyCount
                threadLastReplyAt
                senderFirstName
                senderLastName
                senderImageUrl
                isPinned
                createdAt
                updatedAt
                reactions {
                    chatReactionId
                    chatMessageId
                    userId
                    emoji
                    createdAt
                    firstName
                    lastName
                }
            }
        }
    }
`;
export const GetPinnedMessagesQuery = gql `
    query GetPinnedMessages($chatRoomId: String!) {
        chatMessages {
            pinnedMessages(chatRoomId: $chatRoomId) {
                chatMessageId
                chatRoomId
                senderUserId
                content
                contentText
                isEdited
                senderFirstName
                senderLastName
                senderImageUrl
                isPinned
                createdAt
                reactions {
                    chatReactionId
                    chatMessageId
                    userId
                    emoji
                    createdAt
                    firstName
                    lastName
                }
            }
        }
    }
`;
